<template>
  <div>
    <!-- Dialog de pré-visualização -->
    <v-dialog
        v-model="dialogPreview"
        max-width="900px"
        persistent
        scrollable
    >
      <v-card>
        <v-card-title class="pa-4">
          <v-icon left color="green darken-2">mdi-file-pdf-box</v-icon>
          Requisição #{{ requisicaoAtual?.idrequisicao }}
          <v-spacer></v-spacer>
          <v-btn
              icon
              @click="fecharPreview"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0">
          <div class="pdf-container">
            <vue-pdf-embed
                v-if="pdfDataUrl"
                :source="pdfDataUrl+'#toolbar=0&navpanes=0'"
                style="width: 100%; height: 100%; max-width: 885px"
            ></vue-pdf-embed>
            <div v-else class="d-flex justify-center align-center" style="height: 600px;">
              <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
              ></v-progress-circular>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>

          <v-btn
              outlined
              color="green darken-2"
              @click="imprimirPDF"
              :disabled="!pdfDataUrl"
          >
            <v-icon left>mdi-printer</v-icon>
            Imprimir
          </v-btn>

          <v-btn
              dark
              color="green darken-2"
              @click="baixarPDF"
              :disabled="!pdfDataUrl"
          >
            <v-icon left>mdi-download</v-icon>
            Baixar PDF
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";

export default {
  name: 'RequisicaoPDF',
  components: { VuePdfEmbed },
  data() {
    return {
      logoBase64: 'data:image/png;base64,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',
      dialogPreview: false,
      pdfDataUrl: null,
      requisicaoAtual: null,
      pdfDoc: null,

      // Paleta de cores
      colors: {
        primary: [76, 175, 80],       // Verde padrão para todos os cabeçalhos
        secondary: [76, 175, 80],     // Verde padrão
        accent: [76, 175, 80],        // Verde padrão
        dark: [31, 41, 55],           // Cinza escuro
        light: [249, 250, 251],       // Cinza claro
        text: [55, 65, 81],           // Texto principal
        border: [229, 231, 235]       // Bordas suaves
      }
    }
  },

  methods: {
    async visualizarPDF(requisicao, imagem) {
      try {
        this.requisicaoAtual = requisicao
        this.dialogPreview = true
        this.pdfDataUrl = null

        // Gera o PDF
        const doc = await this.gerarPDF(requisicao, imagem)
        this.pdfDoc = doc

        // Converte para Data URL para exibição
        const pdfBlob = doc.output('blob')
        this.pdfDataUrl = URL.createObjectURL(pdfBlob)

      } catch (error) {
        console.error('Erro ao visualizar PDF:', error)
        this.$emit('erro', 'Erro ao gerar a pré-visualização do PDF')
        this.dialogPreview = false
      }
    },

    async imprimirPDF() {
      if (!this.pdfDoc) return

      try {
        // Abre o PDF em uma nova janela para impressão
        const pdfBlob = this.pdfDoc.output('blob')
        const pdfUrl = URL.createObjectURL(pdfBlob)

        const printWindow = window.open(pdfUrl, '_blank')

        if (printWindow) {
          printWindow.onload = () => {
            printWindow.print()
          }
        } else {
          // Fallback se popup foi bloqueado
          this.$emit('info', 'Permita pop-ups para imprimir o documento')
        }
      } catch (error) {
        console.error('Erro ao imprimir PDF:', error)
        this.$emit('erro', 'Erro ao imprimir o PDF')
      }
    },

    async baixarPDF() {
      if (!this.pdfDoc || !this.requisicaoAtual) return

      try {
        const fileName = `requisicao_abastecimento_${this.requisicaoAtual.idrequisicao}.pdf`
        this.pdfDoc.save(fileName)
        this.$emit('sucesso', 'PDF baixado com sucesso!')
      } catch (error) {
        console.error('Erro ao baixar PDF:', error)
        this.$emit('erro', 'Erro ao baixar o PDF')
      }
    },

    fecharPreview() {
      this.dialogPreview = false

      // Limpa a URL do blob para liberar memória
      if (this.pdfDataUrl) {
        URL.revokeObjectURL(this.pdfDataUrl)
        this.pdfDataUrl = null
      }

      this.requisicaoAtual = null
      this.pdfDoc = null
    },

    async gerarPDF(requisicao, imagem) {
      try {
        const doc = new jsPDF('p', 'mm', 'a4')

        // Configurações do documento
        const pageWidth = doc.internal.pageSize.width
        const pageHeight = doc.internal.pageSize.height
        const margin = 15
        let currentY = 12

        // Função auxiliar para formatar CNPJ
        const formatarCNPJ = (cnpj) => {
          if (!cnpj) return '-'
          const cleaned = cnpj.replace(/\D/g, '')
          if (cleaned.length === 14) {
            return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
          }
          return cnpj
        }

        // Função auxiliar para formatar CEP
        const formatarCEP = (cep) => {
          if (!cep && cep !== 0) return '-'

          const cepStr = String(cep)

          const cleaned = cepStr.replace(/\D/g, '')
          if (cleaned.length === 8) {
            return cleaned.replace(/(\d{5})(\d{3})/, '$1-$2')
          }
          return cepStr
        }

        // BACKGROUND HEADER
        doc.setFillColor(...this.colors.primary)
        doc.rect(0, 0, pageWidth, 25, 'F')

        // CABEÇALHO
        try {
          const logoWidth = 22
          const logoHeight = 22

          // Logo principal
          doc.addImage(this.logoBase64, 'PNG', margin, currentY - 10, logoWidth, logoHeight)
        } catch (error) {
          console.warn('Erro ao adicionar logo:', error)
        }

        // TÍTULO PRINCIPAL
        doc.setTextColor(255, 255, 255)
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(18)
        doc.text('REQUISIÇÃO DE ABASTECIMENTO', pageWidth / 2, currentY , { align: 'center' })

        // Subtítulo
        doc.setFontSize(10)
        doc.setFont('helvetica', 'normal')
        doc.setTextColor(200, 220, 255)
        doc.text('Documento de Controle de Combustível', pageWidth / 2, currentY + 7, { align: 'center' })

        // FAIXA DE INFORMAÇÕES
        const cardX = 15
        const cardY = 25

        // COR DA FAIXA DE INFORMAÇÕES
        doc.setFillColor(2, 64, 89)
        doc.rect(0, cardY, pageWidth, 10, 'F')

        // Informações da faixa
        doc.setFont('helvetica', 'bold')
        doc.setTextColor(255, 255, 255)
        doc.setFontSize(10)
        doc.text(`Número da Requisição: ${requisicao.idrequisicao || '-'}`, cardX, cardY + 6)
        doc.text(`Data de Emissão: ${this.formatarData(requisicao.dtmovimento) || '-'}`, cardX + 65, cardY + 6)

        // Status com cor
        const statusColor = this.getStatusColor(requisicao.idstatus)
        doc.setTextColor(...statusColor)
        doc.text(`Status: ${this.getStatusText(requisicao.idstatus) || '-'}`, cardX + 140, cardY + 6)

        currentY += 34

        // DADOS DA EMPRESA
        currentY = this.criarCardSecao(doc, 'DADOS DO CLIENTE', margin, currentY, pageWidth - margin * 2, this.colors.primary)

        const dadosFilial = [
          [
            { content: `Razão Social\n${ requisicao.filial_razao || '-'}`, colSpan: 2, styles: { halign: 'left', fontStyle: 'bold' } },
            { content: `CNPJ\n${formatarCNPJ( requisicao.filial_cnpj )}`, styles: { fontStyle: 'bold' } },
            { content: `Telefone\n${ requisicao.filial_telefone || '-'}`, styles: { fontStyle: 'bold' } }
          ],
          [
            { content: `Endereço\n${this.truncateText(requisicao.filial_endereco || '-', 40)}`, colSpan: 2, styles: { fontStyle: 'bold' } },
            { content: `Cidade/UF\n${requisicao.filial_cidade}/${requisicao.filial_uf || '-'}`, styles: { fontStyle: 'bold' } },
            { content: `CEP\n${formatarCEP(requisicao.filial_cep)}`, styles: { fontStyle: 'bold' } }
          ],
          [
            { content: `Colaborador\n${this.truncateText(requisicao.colaborador || '-', 28)}`, colSpan: 2, styles: { fontStyle: 'bold' } },
            { content: `Usuário Emissor\n${requisicao.idusuario} - ${this.truncateText(requisicao.usuario || '-', 20)}`, colSpan: 2, styles: { fontStyle: 'bold' } },
          ]
        ]

        doc.autoTable({
          startY: currentY,
          body: dadosFilial,
          theme: 'grid',
          alternateRowStyles: { fillColor: [248, 250, 252] },
          columnStyles: {
            0: { cellWidth: (pageWidth - margin * 2) * 0.25, fontSize: 8 },
            1: { cellWidth: (pageWidth - margin * 2) * 0.25, fontSize: 8 },
            2: { cellWidth: (pageWidth - margin * 2) * 0.25, fontSize: 8 },
            3: { cellWidth: (pageWidth - margin * 2) * 0.25, fontSize: 8 }
          },
          styles: {
            fontSize: 8,
            cellPadding: { top: 2, bottom: 2, left: 3, right: 3 },
            lineColor: this.colors.border,
            lineWidth: 0.1,
            overflow: 'linebreak',
            textColor: this.colors.text,
            valign: 'top'
          },
          margin: { left: margin, right: margin }
        })

        currentY = doc.lastAutoTable.finalY + 10

        // DADOS DO FORNECEDOR
        currentY = this.criarCardSecao(doc, 'DADOS DO FORNECEDOR', margin, currentY, pageWidth - margin * 2, this.colors.primary)

        const dadosFornecedor = requisicao.fornecedor_razaosocial ? [
          [
            { content: `Razão Social\n${requisicao.fornecedor_razaosocial || '-'}`, colSpan: 2, styles: { halign: 'left', fontStyle: 'bold' } },
            { content: `CNPJ\n${formatarCNPJ(requisicao.fornecedor_cnpj)}`, styles: { fontStyle: 'bold' } },
            { content: `Telefone\n-`, styles: { fontStyle: 'bold' } }
          ],
          [
            { content: `Endereço\n${this.truncateText(requisicao.fornecedor_endereco || '-', 40)}`, colSpan: 2, styles: { fontStyle: 'bold' } },
            { content: `Cidade/UF\n${requisicao.fornecedor_cidade}/${requisicao.fornecedor_uf}`, styles: { fontStyle: 'bold' } },
            { content: `CEP\n${formatarCEP(requisicao.fornecedor_cep)}`, styles: { fontStyle: 'bold' } }
          ]
        ] : [
          [
            { content: `Razão Social\n-`, colSpan: 2, styles: { halign: 'left', fontStyle: 'bold' } },
            { content: `CNPJ\n-`, styles: { fontStyle: 'bold' } },
            { content: `Telefone\n-`, styles: { fontStyle: 'bold' } }
          ],
          [
            { content: `Endereço\n-`, colSpan: 2, styles: { fontStyle: 'bold' } },
            { content: `Cidade/UF\n-`, styles: { fontStyle: 'bold' } },
            { content: `CEP\n-`, styles: { fontStyle: 'bold' } }
          ]
        ]

        doc.autoTable({
          startY: currentY,
          body: dadosFornecedor,
          theme: 'grid',
          alternateRowStyles: { fillColor: [248, 250, 252] },
          columnStyles: {
            0: { cellWidth: (pageWidth - margin * 2) * 0.25, fontSize: 8 },
            1: { cellWidth: (pageWidth - margin * 2) * 0.25, fontSize: 8 },
            2: { cellWidth: (pageWidth - margin * 2) * 0.25, fontSize: 8 },
            3: { cellWidth: (pageWidth - margin * 2) * 0.25, fontSize: 8 }
          },
          styles: {
            fontSize: 8,
            cellPadding: { top: 2, bottom: 2, left: 3, right: 3 },
            lineColor: this.colors.border,
            lineWidth: 0.1,
            overflow: 'linebreak',
            textColor: this.colors.text,
            valign: 'top'
          },
          margin: { left: margin, right: margin }
        })

        currentY = doc.lastAutoTable.finalY + 10

        // DADOS DO VEÍCULO E ABASTECIMENTO
        currentY = this.criarCardSecao(doc, 'DADOS DO VEÍCULO E ABASTECIMENTO', margin, currentY, pageWidth - margin * 2, this.colors.primary)

        const veiculo = requisicao.veiculo || '-'
        const placa = requisicao.placa
        const odometro = requisicao.odometro ? `${Number(requisicao.odometro).toLocaleString('pt-BR')} KM` : '-'

        // Linha de veículo (com ou sem placa)
        const linhaVeiculo = [
          {
            content: `Veículo\n${this.truncateText(veiculo, 25)}`,
            colSpan: placa !== '-' ? 2 : 4,
            styles: { fontStyle: 'bold' }
          }
        ]
        if (placa !== '-') {
          linhaVeiculo.push(
              {
                content: `Placa\n${placa}`,
                styles: { fontStyle: 'bold' }
              },
              {
                content: `Hodômetro\n${odometro}`,
                styles: { fontStyle: 'bold' }
              }
          )
        }

        // Demais linhas
        const linhaCombustivel = [
          {
            content: `Combustível\n${requisicao.produto || '-'}`,
            styles: { halign: 'left', fontStyle: 'bold' }
          },
          {
            content: `Tipo do Abastecimento\n${requisicao.tipoabastecimento || '-'}`,
            styles: { fontStyle: 'bold' }
          },
          {
            content: `Litros\n${requisicao.quantidade ? `${Number(requisicao.quantidade).toLocaleString('pt-BR')} L` : '-'}`,
            styles: { fontStyle: 'bold' }
          },
          {
            content: `Valor\n${requisicao.valortotal ? this.formatarMoeda(requisicao.valortotal) : '-'}`,
            styles: { fontStyle: 'bold' }
          }
        ]

        const linhaObservacoes = [
          {
            content: `Observações\n${requisicao.observacao || '-'}`,
            colSpan: 4,
            styles: { halign: 'left', fontStyle: 'bold' }
          }
        ]

        // Monta a tabela final
        const dadosVeiculoAbastecimento = [
          linhaVeiculo,
          linhaCombustivel,
          linhaObservacoes
        ]

        doc.autoTable({
          startY: currentY,
          body: dadosVeiculoAbastecimento,
          theme: 'grid',
          tableWidth: 'auto',
          alternateRowStyles: { fillColor: [248, 250, 252] },
          styles: {
            fontSize: 8,
            cellPadding: { top: 2, bottom: 2, left: 3, right: 3 },
            lineColor: this.colors.border,
            lineWidth: 0.1,
            overflow: 'linebreak',
            textColor: this.colors.text,
            valign: 'top'
          },
          margin: { left: margin, right: margin }
        })

        currentY = doc.lastAutoTable.finalY + 15

        currentY = 205

        // SEÇÃO DE ASSINATURA E ANEXO DE ODÔMETRO
        doc.setFontSize(12)
        doc.setFont('helvetica', 'bold')
        doc.setTextColor(...this.colors.primary)
        doc.text('ASSINATURA', margin+30, currentY)
        if (odometro !== '-') {
          doc.text('COMPROVANTE ODÔMETRO', margin + 108, currentY)
        }

        currentY += 8

        // Dimensões dos cards
        const cardWidth = 85
        const cardHeight = 50
        const espacoEntreCards = 10

        // CARD DE ASSINATURA
        const assinaturaX = margin
        const assinaturaY = currentY

        doc.setFillColor(0, 0, 0, 0.05)
        doc.roundedRect(assinaturaX + 1, assinaturaY + 1, cardWidth, cardHeight, 3, 3, 'F')

        // Card principal de assinatura
        doc.setFillColor(252, 252, 253)
        doc.roundedRect(assinaturaX, assinaturaY, cardWidth, cardHeight, 3, 3, 'F')

        // Borda do card de assinatura
        doc.setDrawColor(...this.colors.border)
        doc.setLineWidth(0.5)
        doc.roundedRect(assinaturaX, assinaturaY, cardWidth, cardHeight, 3, 3, 'S')

        // Linha para assinatura
        const linhaAssinaturaY = assinaturaY + cardHeight - 12
        doc.setDrawColor(100, 100, 100)
        doc.setLineWidth(0.5)
        doc.line(assinaturaX + 10, linhaAssinaturaY, assinaturaX + cardWidth - 10, linhaAssinaturaY)

        // Texto da assinatura
        doc.setFontSize(9)
        doc.setFont('helvetica', 'normal')
        doc.setTextColor(100, 100, 100)
        doc.text('Autorização', assinaturaX + cardWidth/2, linhaAssinaturaY + 6, { align: 'center' })

        if (odometro !== '-') {
          // CARD DE ANEXO DE ODÔMETRO
          const anexoX = assinaturaX + cardWidth + espacoEntreCards
          const anexoY = currentY

          // Sombra do card de anexo
          doc.setFillColor(0, 0, 0, 0.05)
          doc.roundedRect(anexoX + 1, anexoY + 1, cardWidth, cardHeight, 3, 3, 'F')

          // Card principal de anexo
          doc.setFillColor(252, 252, 253)
          doc.roundedRect(anexoX, anexoY, cardWidth, cardHeight, 3, 3, 'F')

          // Borda do card de anexo
          doc.setDrawColor(...this.colors.border)
          doc.setLineWidth(0.5)
          doc.roundedRect(anexoX, anexoY, cardWidth, cardHeight, 3, 3, 'S')

          // Conteúdo do card de anexo
          if (imagem) {
            try {
              // adiciona ela se houver
              await this.adicionarImagemOdometro(doc, imagem, anexoX, anexoY, cardWidth, cardHeight)
            } catch (error) {
              console.warn('Erro ao adicionar imagem do odômetro:', error)
              // Fallback para quando há erro na imagem
              this.adicionarPlaceholderAnexo(doc, anexoX, anexoY, cardWidth, cardHeight, true)
            }
          } else {
            // Se não há imagem, mostra placeholder
            this.adicionarPlaceholderAnexo(doc, anexoX, anexoY, cardWidth, cardHeight, false)
          }
        }

        // RODAPÉ
        const footerY = pageHeight - 15

        // Background
        doc.setFillColor(...this.colors.light)
        doc.rect(0, footerY - 8, pageWidth, 15, 'F')

        // Linha decorativa
        doc.setDrawColor(...this.colors.primary)
        doc.setLineWidth(2)
        doc.line(margin, footerY - 8, pageWidth - margin, footerY - 8)

        // Informações do rodapé
        doc.setFontSize(7)
        doc.setFont('helvetica', 'normal')
        doc.setTextColor(...this.colors.text)
        doc.text(`Documento gerado em: ${new Date().toLocaleString('pt-BR')}`, margin, footerY - 2)
        doc.text('Página 1 de 1', pageWidth - margin, footerY - 2, { align: 'right' })

        return doc

      } catch (error) {
        console.error('Erro ao gerar PDF:', error)
        throw error
      }
    },

    async adicionarImagemOdometro(doc, imagemBase64, x, y, cardWidth, cardHeight) {
      return new Promise((resolve, reject) => {
        try {
          // Criar uma imagem temporária para obter dimensões originais
          const img = new Image()

          imagemBase64 = `data:image/png;base64,${imagemBase64}`

          img.onload = () => {
            try {
              // Dimensões originais da imagem
              const originalWidth = img.width
              const originalHeight = img.height

              // Área disponível para a imagem
              const availableWidth = cardWidth - 6  // 3px padding em cada lado
              const availableHeight = cardHeight - 18 // espaço para texto embaixo

              // Calcular proporção
              const widthRatio = availableWidth / originalWidth
              const heightRatio = availableHeight / originalHeight
              const scale = Math.min(widthRatio, heightRatio)

              // Dimensões finais da imagem
              const finalWidth = originalWidth * scale
              const finalHeight = originalHeight * scale

              // Calcular posição para centralizar a imagem
              const imageX = x + 3 + (availableWidth - finalWidth) / 2
              const imageY = y + 3 + (availableHeight - finalHeight) / 2

              // Adicionar a imagem com as dimensões calculadas
              doc.addImage(imagemBase64, 'JPEG', imageX, imageY, finalWidth, finalHeight)

              doc.setFontSize(8)
              doc.setFont('helvetica', 'bold')
              doc.setTextColor(...this.colors.text)
              doc.text('ANEXO', x + cardWidth/2, y + cardHeight - 3, { align: 'center' })

              resolve()
            } catch (error) {
              reject(error)
            }
          }

          img.onerror = () => {
            reject(new Error('Falha ao carregar imagem'))
          }

          // Definir src da imagem
          img.src = imagemBase64

        } catch (error) {
          reject(error)
        }
      })
    },

    adicionarPlaceholderAnexo(doc, x, y, width, height, temErro = false) {
      // Área para a imagem
      const imgAreaHeight = height - 15
      doc.setFillColor(245, 245, 245)
      doc.rect(x + 3, y + 3, width - 6, imgAreaHeight, 'F')

      // Borda pontilhada da área da imagem
      doc.setDrawColor(200, 200, 200)
      doc.setLineWidth(0.3)
      doc.setLineDashPattern([2, 2], 0)
      doc.rect(x + 3, y + 3, width - 6, imgAreaHeight, 'S')
      doc.setLineDashPattern([], 0) // Reset dash pattern

      // Ícone de imagem
      const iconSize = 12
      const iconX = x + width/2 - iconSize/2
      const iconY = y + imgAreaHeight/2 - iconSize/2 + 3

      // Desenha um retângulo como ícone
      doc.setFillColor(180, 180, 180)
      doc.rect(iconX, iconY, iconSize, iconSize * 0.7, 'F')

      doc.setFillColor(220, 220, 220)
      doc.circle(iconX + iconSize - 3, iconY + 3, 2, 'F')

      // Texto do placeholder
      doc.setFontSize(8)
      doc.setFont('helvetica', 'normal')
      doc.setTextColor(120, 120, 120)

      if (temErro) {
        doc.text('Erro ao carregar', x + width/2, iconY + iconSize + 4, { align: 'center' })
        doc.text('imagem', x + width/2, iconY + iconSize + 8, { align: 'center' })
      } else {
        doc.text('Anexar foto do', x + width/2, iconY + iconSize + 4, { align: 'center' })
        doc.text('odômetro', x + width/2, iconY + iconSize + 8, { align: 'center' })
      }

      // Status text
      doc.setFontSize(8)
      doc.setFont('helvetica', 'bold')
      doc.setTextColor(temErro ? 200 : 150, temErro ? 80 : 150, temErro ? 80 : 150)
      doc.text(temErro ? 'ERRO' : 'PENDENTE', x + width/2, y + height - 3, { align: 'center' })
    },

    criarCardSecao(doc, titulo, x, y, width, color) {
      const headerHeight = 8

      // Sombra do header
      doc.setFillColor(0, 0, 0, 0.1)
      doc.roundedRect(x + 0.5, y + 0.5, width, headerHeight, 2, 2, 'F')

      // Header do card
      doc.setFillColor(...color)
      doc.roundedRect(x, y, width, headerHeight, 2, 2, 'F')

      // Título do card
      doc.setFontSize(9)
      doc.setFont('helvetica', 'bold')
      doc.setTextColor(255, 255, 255)
      doc.text(titulo, x + 3, y + 5.5)

      return y + headerHeight + 2
    },

    getStatusColor(idstatus) {
      const colors = {
        1: [255, 193, 7],    // Amarelo - Aguardando
        2: [40, 167, 69],    // Verde - Concluído
      }
      return colors[idstatus] || this.colors.text
    },

    setLogo(logoBase64) {
      this.logoBase64 = logoBase64
    },

    truncateText(text, maxLength) {
      if (!text) return '-'
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength - 3) + '...'
    },

    formatarData(data) {
      if (!data) return '';
      const [ano, mes, dia] = data.split('-');
      return `${dia}/${mes}/${ano}`;
    },

    formatarMoeda(valor) {
      if (!valor) return '-'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor)
    },

    getStatusText(idstatus) {
      const texts = {
        1: 'Aguardando',
        2: 'Concluído',
      }
      return texts[idstatus] || idstatus
    },
  },

  beforeDestroy() {
    // Limpa URLs de blob ao destruir o componente
    if (this.pdfDataUrl) {
      URL.revokeObjectURL(this.pdfDataUrl)
    }
  },

  mounted() {
    // Remover após os testes
    // this.testarConversaoGoogleDrive();
  }
}
</script>

<style scoped>
.pdf-container {
  background-color: #f5f5f5;
  border-radius: 4px;
}

.v-dialog > .v-card > .v-card-title {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.v-dialog > .v-card > .v-card-actions {
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
}
</style>